import { createTheme } from '@mui/material'
import { ThemeProvider } from '@emotion/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import About from './Pages/About';
import Careers from './Pages/Careers';
import Contact from './Pages/Contact';
import Terms from './Pages/Terms';
import Privacy from './Pages/Privacy';
import Booking from './Pages/Booking';
import Apply from './Pages/Apply';
import Frequently from './Pages/Frequently';
import ApplyNow from './Pages/Applynow';
import CreditCard from './Pages/CreditCard';


function App() {

  const theme = createTheme({
    palette: {
      primary: {
        main: '#4A3FFF'
      },
      secondary: {
        main: '#7badf9'
      }
    },

    typography: {
      fontFamily: "Fustat-Medium",
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightBold: 800,
      fontSize: 20
    }
  })

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route exact path='/' element={<Home title={"Welcome | BrightStarr"} />} />
          <Route exact path='/about' element={<About title={"About Us | BrightStarr"} />} />
          <Route exact path='/careers' element={<Careers title={"BrightStarr"} />} />
          <Route exact path='/career' element={<Careers title={"BrightStarr"} />} />
          <Route exact path='/contact' element={<Contact title={"Contact Us | BrightStarr"} />} />
          <Route exact path='/faq' element={<Frequently title={"BrightStarr"} />} />
          <Route exact path='/terms' element={<Terms title={"Terms | BrightStarr"} />} />
          <Route exact path='/privacy' element={<Privacy title={"Privacy Policiy | BrightStarr"} />} />
          <Route exact path='/book' element={<Booking title={"BrightStarr"} />} />
          <Route exact path='/apply' element={<Apply title={"BrightStarr"} />} />
          <Route exact path='/applynow' element={<ApplyNow title={"BrightStarr"} />} />
          <Route exact path='/creditcard' element={<CreditCard title={"BrightStarr"} />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
